<template>
  <v-data-table
    :headers="headers"
    :items="orgTaxRates"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="OrgTaxRate-button-new"
          @click="$router.push({
            name: 'quotes-EditOrgTaxRate'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'quotes-EditOrgTaxRate',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import list from '~src/mixins/list';

export default {
  name: 'ListOrgTaxRate',
  module: 'OrgTaxRate',
  components: {
    TableBasicButtons,
  },
  mixins: [list, loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('orgTaxRates', ['orgTaxRates']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('taxType'),
          value: 'taxType',
        },
        {
          text: this.$$t('taxName'),
          value: 'taxName',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_orgTaxRates();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('orgTaxRates', ['LOAD_orgTaxRates', 'DELETE_orgTaxRate']),
    /** Delete OrgTaxRate from the collection
     */
    async remove(orgTaxRate) {
      this.isLoading = true;
      await this.DELETE_orgTaxRate(orgTaxRate.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# OrgTaxRate example

'''js
<OrgTaxRate />
'''
</docs>
